
 const Mtb= {
  minmaxBHCurr:'45vh',
  minmaxBHInvs:'65vh',
  minmaxBHSub:'48vh',
  // minBH:'48vh',
 }

 export {Mtb}